<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData" />
                <div v-else>
                    <div
                        class="md:bg-white md:px-5 lg:px-7 rounded-b-lg"
                        :class="['md:pb-4 md:pt-6']"
                    >
                        <h4 class="text-secondary mb-2.5 font-bold">
                            請選擇欲變更之內容
                        </h4>
                        <Radio
                            v-model:checked-value="editData.selected"
                            value="A"
                            text="新增/變更指定聯絡人"
                            class="mb-2.5 items-baseline"
                        />
                        <Radio
                            v-model:checked-value="editData.selected"
                            :disabled="!editData.beforeApplyStatus"
                            value="T"
                            text="終止約定指定聯絡人"
                            class="mb-2.5 items-baseline"
                        />
                    </div>
                    <div
                        v-if="editData.selected === 'A'"
                        class="md:bg-white md:px-5 lg:px-7 rounded-b-lg"
                        :class="['md:pb-4 md:pt-6']"
                    >
                        <template v-for="(data, index) in editData.assignContactArray">
                            <InputForm
                                v-model:isOpen="data.isOpen"
                                :title="`聯絡人${index+1}資訊`"
                                class="border-t"
                                :idx="index"
                                @resetValues="(i)=>{
                                    resetValues(i,data)
                                }"
                            >
                                <template v-if="!data.isOpen" #data>
                                    <ul
                                        class="space-y-2 pb-2 md:min-h-[2rem]"
                                    >
                                        <template v-if="isEmptyData(data)">
                                            <li>
                                                系統無資料，如需增加，請點選變更。
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li v-if="data.name">
                                                {{ data.name }}
                                            </li>
                                            <li v-if="data.id">
                                                {{ data.id }}
                                            </li>
                                            <li v-if="data.relation">
                                                {{ relationArray?.find(p => p.value === data.relation)?.label }}
                                            </li>
                                            <li v-if="data.mobile">
                                                {{ getMobileCountry(data.mobileCountry) }}
                                                {{ data.mobile }}
                                            </li>
                                            <li
                                                v-if="data.email"
                                                class="break-all"
                                            >
                                                {{ data.email }}
                                            </li>
                                        </template>
                                    </ul>
                                </template>
                                <template #inputs>
                                    <div class="text-base xs:text-lg">
                                        <div class="flex  mb-5">
                                            <div class="flex flex-col mb-5 mr-10">
                                                <h4
                                                    class="mb-3 mt-4 md:mt-5"
                                                >
                                                    姓名
                                                </h4>
                                                <div class="relative">
                                                    <input
                                                        v-model="data.name"
                                                        type="text"
                                                        name="username"
                                                        autocomplete="off"
                                                        class="rounded h-12 text-sm placeholder-gray-500 px-4 rounded-xl border border-gray-200 w-full py-2 focus:outline-none focus:border-blue-400"
                                                        placeholder="請輸入姓名"
                                                        @input="(e)=> {
                                                            data.name = handleNameInput(e)
                                                        }"
                                                    >
                                                    <p class="error-msg" />
                                                </div>
                                            </div>
                                            <div class="flex flex-col mb-5 mr-10">
                                                <h4
                                                    class="mb-3 mt-4 md:mt-5"
                                                >
                                                    身分證號碼/居留證統一證號
                                                </h4>
                                                <div class="relative ">
                                                    <input
                                                        v-model="data.id"
                                                        type="text"
                                                        name="username"
                                                        autocomplete="off"
                                                        class="rounded h-12 text-sm placeholder-gray-500 px-4 rounded-xl border border-gray-200 w-full py-2 focus:outline-none focus:border-blue-400"
                                                        placeholder="請輸入身分證號碼/居留證統一證號"
                                                    >
                                                    <p class="error-msg" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex flex-col mb-5 border-t pb-3">
                                            <h4
                                                class="mb-3 mt-4 md:mt-5"
                                            >
                                                與要保人關係
                                            </h4>
                                            <div class="relative">
                                                <div
                                                    class="mr-2 mb-2 md:mb-0 max-w-[12.5rem] w-[calc(50%-0.25rem)] md:w-[22%]"
                                                >
                                                    <Multiselect
                                                        v-model="data.relation"
                                                        class="select-base"
                                                        :options="relationArray"
                                                        placeholder="請選擇"
                                                        :can-clear="false"
                                                        :can-deselect="false"
                                                        @select="()=>{
                                                        }"
                                                    />
                                                </div>
                                                <p class="error-msg" />
                                            </div>
                                        </div>

                                        <div
                                            class="flex flex-col mb-5 border-t pb-3"
                                        >
                                            <h4
                                                class="mb-3 mt-4 md:mt-5"
                                            >
                                                行動電話
                                            </h4>
                                            <div class="relative">
                                                <div
                                                    class="gray-dashed"
                                                >
                                                    <div class="flex flex-wrap">
                                                        <div
                                                            class="md:mb-0 mr-2 max-w-[12.5rem] w-[calc(50%-0.25rem)] md:w-[12.5rem]"
                                                        >
                                                            <Multiselect
                                                                v-model="data.mobileCountry"
                                                                class="select-base"
                                                                placeholder="國碼"
                                                                track-by="text"
                                                                label="label"
                                                                :options="telCode"
                                                                :can-clear="false"
                                                                :can-deselect="false"
                                                                @select="validateMobile(data)"
                                                            />
                                                            <div class="error-msg">
                                                                {{ data.errors?.mobileCountry }}
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="md:mr-2 w-[calc(50%-0.25rem)] md:w-auto max-w-[12.5rem]"
                                                        >
                                                            <input
                                                                v-model.trim="data.mobile"
                                                                class="input-base"
                                                                inputmode="numeric"
                                                                autocomplete="off"
                                                                maxlength="11"
                                                                type="text"
                                                                placeholder="行動電話"
                                                                :disabled="!data.mobileCountry"
                                                                @blur="validateMobile(data)"
                                                            >
                                                            <div class="error-msg mb-3">
                                                                {{ data.errors?.mobile }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <p class="error-msg" />
                                            </div>
                                        </div>

                                        <div
                                            class="flex flex-col mb-5 border-t pb-3"
                                        >
                                            <h4
                                                class="mb-3 mt-4 md:mt-5"
                                            >
                                                E-mail
                                            </h4>
                                            <div class="relative">
                                                <div
                                                    class="gray-dashed"
                                                >
                                                    <div
                                                        class="flex flex-col items-end sm:flex-row space-x-1 sm:items-baseline"
                                                    >
                                                        <div
                                                            class="w-full sm:w-[calc(100%-190px)] md:w-[52%] md:max-w-[25.1875rem]"
                                                        >
                                                            <input
                                                                v-model.trim="data.email"
                                                                :name="`users.email`"
                                                                class="input-base"
                                                                maxlength="264"
                                                                inputmode="email"
                                                                autocomplete="off"
                                                                type="text"
                                                                placeholder="電子信箱"
                                                                @input="validateEmail(data)"
                                                            >
                                                            <div class="error-msg">
                                                                {{ data.errors?.email }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p class="error-msg" />
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </InputForm>
                        </template>
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar :control-visible="editData.selected!==''">
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    v-model:isGetButtonInfo="isGetButtonInfo"
                    :disabled="editData.selected===''"
                    @click="handleSubmit"
                />
            </template>
        </Bottombar>
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import { computed, reactive, ref, toRefs } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getInfoBA, submitBA } from '@/apis/BA';

import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import Skeletons from './Skeletons.vue';
import InputForm from '@/components/collapse/CollapseFrame.vue';
import { commonValidateEmail, commonValidMobile } from '@/views/aplCatl640and631/BCBD/landingPage/validate';
import { getTelSelectList } from '@/views/aplCatl640and631/BCBD/landingPage/getSelectList';
import Multiselect from '@vueform/multiselect';
import { clearDetailsField, openPopupCatch, openPopupCatchMessage } from '@/utils/vfmUtils';

export default {
    components: {
        InputForm,
        Multiselect,
        Bottombar,
        Loading,
        Radio,
        ButtonNextService,
        Skeletons,
    },
    setup() {
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const isGetButtonInfo = ref(false);
        const isSubmitOk = ref(false);
        const isLoading = ref(false);
        const isGettingData = ref(false);
        const editData = ref({
            selected: '',
            assignContactArray: [],
        });

        const relationArray = ref([
            {
                label: '配偶',
                value: '1',
            },
            {
                label: '父母',
                value: '2',
            },
            {
                label: '子女',
                value: '3',
            },
            {
                label: '兄弟姊妹',
                value: '4',
            },
            {
                label: '(外)祖孫',
                value: '5',
            },
        ]);

        const result = computed(() => store.state.services.changeItemsResult[code]);
        const {
            telCode,
        } = getTelSelectList(result.value, 'BC');

        // 取得api資料
        const getData = () => {
            isGettingData.value = true;
            getInfoBA().then((res) => {
                // const keys = Object.keys(res.data);
                // keys.forEach(k => {
                //     data[k] = res.data[k];
                // });
                editData.value.beforeApplyStatus = res.data.beforeApplyStatus;
                editData.value.assignContactArray = [];
                res.data?.assignContactVos?.forEach(item => {
                    const initData = {
                        id: item.id || '',
                        name: item.name || '',
                        relation: item.relation || '',
                        mobileCountry: item.mobileCountry || '',
                        mobile: item.mobile || '',
                        email: item.email || '',
                        initialData: {},
                        isOpen: false,
                        errors: {},
                    };
                    initData.initialData = JSON.parse(JSON.stringify(initData));
                    editData.value.assignContactArray.push(initData);
                });
                const c = 2 - editData.value.assignContactArray.length;
                if (c > 0) {
                    for (let i = 0; i < c; i++) {
                        const initData = {
                            id: '',
                            name: '',
                            relation: '',
                            mobileCountry: '',
                            mobile: '',
                            email: '',
                            initialData: {},
                            isOpen: false,
                            errors: {},
                        };
                        initData.initialData = JSON.parse(JSON.stringify(initData));
                        editData.value.assignContactArray.push(initData);
                    }
                }
            }).finally(() => {
                isGettingData.value = false;
            });
        };
        if (!result.value) {
            getData();
        } else {
            const {
                editDataVal,
            } = result.value;
            editData.value = editDataVal;
        }
        const handleSubmit = () => {
            isLoading.value = true;
            const data = {
                selected: editData.value.selected,
                assignContactList: editData.value.assignContactArray,
            };
            submitBA(data).then(() => {
                const value = {
                    editDataVal: editData.value,
                    telCodeList: telCode.value,
                };
                store.dispatch('services/setChangeItemsResult', {
                    code,
                    value,
                });
                isSubmitOk.value = true;
            }).catch((ex) => {
                clearDetailsField(ex);
                openPopupCatchMessage(ex);
            }).finally(() => {
                isLoading.value = false;
            });
        };

        /** 取消變更時 區塊資料reset */
        const resetValues = (idx, data) => {
            const initialData = data.initialData;
            Object.assign(data, initialData);
            Object.keys(initialData).forEach(key => {
                if (!key === 'initialData') {
                    data[key] = initialData[key];
                }
            });
        };

        /** validate Email */
        const validateEmail = (item) => {
            const {
                email,
                requiredList,
            } = item;
            item.errors.email = commonValidateEmail({
                mail: email,
                isRequired: false,
            });
        };

        /** validate Mobile */
        const validateMobile = (item) => {
            const {
                mobileCountry,
                mobile,
                requiredList,
            } = item;
            item.errors.mobile = commonValidMobile({
                mobileCountry,
                mobile,
                isRequired: true,
            });
        };
        /** 取得手機國碼  886不用顯示在畫面 */
        const getMobileCountry = (tel) => {
            if (tel === '') return '';
            const telCodeObj = telCode.value.filter(i => i.value === tel);
            return telCodeObj[0].value === '886' ? '' : telCodeObj[0].label;
        };
        const fieldNameList = {
            id: '身分證',
            name: '姓名',
            relation: '關係',
            mobileCountry: '國碼',
            mobile: '行動電話',
            email: 'E-mail',
        };
        const isEmptyData = (item) => {
            const i = Object.assign({}, item);
            const keys = Object.keys(fieldNameList);
            let dataList = keys.map(key => {
                return i[key];
            });
            dataList = dataList.filter(j => j);
            let hasData = '';
            if (i.id === 'mobile') {
                hasData = Object.values(dataList).join('').trim() === '886';
            } else {
                hasData = Object.values(dataList).join('').trim() === '';
            }
            return hasData;
        };
        const handleNameInput = (event) => {
            let input = event.target.value;

            input = input.replace(/\d/g, '');

            // 轉換為全形字元
            const fullWidth = input.split('').map(char => {
                const code = char.charCodeAt(0);
                if (code === 32) {
                    return String.fromCharCode(12288); // 全形空白
                }
                if (code >= 33 && code <= 126) {
                    return String.fromCharCode(code + 65248); // 全形字元
                }
                return char;
            }).join('');
            event.target.value = fullWidth;
            return fullWidth;
        };
        return {
            isGetButtonInfo,
            isLoading,
            isGettingData,
            handleSubmit,
            isSubmitOk,
            editData,
            resetValues,
            validateEmail,
            validateMobile,
            getMobileCountry,
            telCode,
            relationArray,
            isEmptyData,
            handleNameInput,
        };
    },
};
</script>
